import { makeStyles } from "makeStyles";
import { StoragePermissionsResult } from "../models";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { permissionsTableStyles } from "../styles";
import { useState, useMemo } from "react";
import { TableSortOrder, getComparator, SimpleSortableTableHeadProps, SortableTableHead } from "../SortableTableHead";
import FilesRights from "./FilesRights";

const useStyles = makeStyles()((theme) => ({
  ...permissionsTableStyles(theme),
  libraryNameCell: {
    width: "220px"
  }
}));

interface Props {
  storages?: StoragePermissionsResult[];
}

const AppAccessFiles: React.FunctionComponent<Props> = (props) => {
  const { classes } = useStyles();

  const [order, setOrder] = useState<TableSortOrder>("asc");
  const [orderBy, setOrderBy] = useState<keyof StoragePermissionsResult>("storageName");

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof StoragePermissionsResult) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const displayRows = useMemo(() => [...(props.storages ?? [])].sort(getComparator(order, orderBy)), [order, orderBy, props.storages]);

  function StoragesTableHead({ id, label, className }: SimpleSortableTableHeadProps<StoragePermissionsResult>) {
    return (
      <SortableTableHead
        className={className}
        headCell={{
          id,
          label
        }}
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
      />
    );
  }

  return (
    <TableContainer component={Paper} className={classes.topLevelTableContainer}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <StoragesTableHead id="storageName" label="Document Library Name" className={classes.libraryNameCell} />
            <TableCell>Access Rights</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {displayRows?.map((storage) => (
            <TableRow key={storage.storageName}>
              <TableCell>{storage.storageName}</TableCell>
              <TableCell>
                {storage.isError ? (
                  <Typography variant="caption">{storage.errorMessage}</Typography>
                ) : (
                  <FilesRights rights={storage.roleResults} />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AppAccessFiles;
